// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.reasons-label {
  color: #065b9d;
  font-weight: 550;
  font-size: 1.2rem;
}
.reasons-label span {
  font-weight: 700;
}

.input-subtext {
  font-style: italic;
  font-weight: 500;
  font-size: 0.8rem;
}

.black-over-yellow {
  color: #444343;
}

.card-active {
  border-radius: 10px 10px 0 0;
  background: #D1D3D4;
  border-color: #0669B3 #0669B3 #D1D3D4 #0669B3;
  border-style: solid;
  border-width: 2px;
  bottom: -2px;
  z-index: 999;
}

.reasons-flex {
  display: flex;
  flex-wrap: wrap;
}

.reasons-flex-col {
  display: flex;
  flex-direction: column;
}

.reasons-heading {
  font-weight: 600;
  font-size: 1.3rem;
  margin-bottom: 15px;
}

.reasons-leaving-background {
  border-radius: 10px;
  background: #EDf0F1;
  margin: 0 auto;
  padding: 20px 30px;
}

.reasons-background {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #D1D3D4;
  border: 2px solid #0669B3;
  margin: 0 auto;
  padding: 0px 30px;
  padding-bottom: 50px;
}
.reasons-background .top-text {
  font-weight: 600;
}
.reasons-background .testing {
  font-weight: 700;
}
.reasons-background span {
  font-weight: 550;
}

.reasons-container {
  display: flex;
  position: relative;
}

.options {
  border-radius: 50px;
  border: 1px solid #707070;
  padding: 5px 15px;
  margin: 5px 43px;
  height: 33px;
  width: 500px;
  background: white;
}
.options input[type=checkbox] {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.options input[type=text] {
  border-radius: 10px;
  background: white;
  border: 1px solid #D1D3D4;
  height: 25px;
  padding-left: 10px;
  min-width: 85%;
}
.options label {
  font-size: 0.9rem;
  min-width: 90px;
}

.options.checked {
  background: #0669B3;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/ReasonsBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,cDuBY;ECtBZ,gBAAA;EACA,iBAAA;AAUJ;AARI;EACI,gBAAA;AAUR;;AAPA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AAUJ;;AARA;EACI,cDMK;ACKT;;AATA;ECjBI,4BDkBsB;EACtB,mBDHI;ECIJ,6CAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAYJ;;AAVA;EACI,aAAA;EACA,eAAA;AAaJ;;AAXA;EACI,aAAA;EACA,sBAAA;AAcJ;;AAXA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;AAcJ;;AAXA;ECzCI,mBD0CsB;EACtB,mBD5BI;EC6BJ,cAAA;EACA,kBAAA;AAcJ;;AAXA;EChDI,mBDiDsB;EACtB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBDrCI;ECsCJ,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AAcJ;AAZI;EACI,gBAAA;AAcR;AAXI;EACI,gBAAA;AAaR;AAXI;EACI,gBAAA;AAaR;;AATA;EAGI,aAAA;EACA,kBAAA;AAUJ;;AAPA;EC9EI,mBD+EsB;EACtB,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAUJ;AARI;EACI,WAAA;EACA,YAAA;EAEA,kBAAA;AASR;AAPI;EC7FA,mBD8F0B;EACtB,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AASR;AAPI;EACI,iBAAA;EACA,eAAA;AASR;;AANA;EACI,mBDrFS;AC8Fb","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"./global/Colors.scss\";\n@import \"./global/globalMixins.scss\";\n\n.reasons-label {\n    color: $dk-pearl-blue;\n    font-weight: 550;\n    font-size: 1.2rem;\n\n    span {\n        font-weight: 700;\n    }\n}\n.input-subtext {\n    font-style: italic;\n    font-weight: 500;\n    font-size: .8rem;\n}\n.black-over-yellow {\n    color: $grey4a;\n}\n.card-active {\n    @include borderRadius(10px 10px 0 0);\n    background: $grey1;\n    border-color: $pearl-blue $pearl-blue $grey1 $pearl-blue;\n    border-style: solid;\n    border-width: 2px;\n    bottom: -2px;\n    z-index: 999;\n}\n.reasons-flex {\n    display: flex;\n    flex-wrap: wrap;\n}\n.reasons-flex-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.reasons-heading {\n    font-weight: 600;\n    font-size: 1.3rem;\n    margin-bottom: 15px;\n}\n\n.reasons-leaving-background {\n    @include borderRadius(10px);\n    background: $grey0;\n    margin: 0 auto;\n    padding: 20px 30px\n}\n\n.reasons-background {\n    @include borderRadius(10px);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    background: $grey1;\n    border: 2px solid $pearl-blue;\n    margin: 0 auto;\n    padding: 0px 30px;\n    padding-bottom: 50px;\n\n    .top-text {\n        font-weight: 600;\n    }\n\n    .testing {\n        font-weight: 700;\n    }\n    span {\n        font-weight: 550;\n    }\n}\n\n.reasons-container {\n    // border: 2px solid red;\n    // width: 100%;\n    display: flex;\n    position: relative;\n    // left: -320px;\n}\n.options {\n    @include borderRadius(50px);\n    border: 1px solid $grey3a;\n    padding: 5px 15px;\n    margin: 5px 43px;\n    height: 33px;\n    width: 500px;\n    background: white;\n\n    input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n        // background:white;\n        margin-right: 10px;\n    }\n    input[type=\"text\"] {\n        @include borderRadius(10px);;\n        background: white;\n        border: 1px solid $grey1;\n        height: 25px;\n        padding-left: 10px;\n        min-width: 85%;\n    }\n    label {\n        font-size: 0.9rem;\n        min-width: 90px;\n    }\n}\n.options.checked {\n    background: $pearl-blue;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
